<template>
  <div class="min-md:bg-neutral-50 min-md:px-16 min-md:py-10 w-full">
    <!-- <PensionPortfolioPartialsRecommendation
      class="mb-6 border-b pb-6 md:px-5 md:py-6"
      :recommendationId="policy.recommendationId"
    /> -->
    <ScreenComponent :policy :category />
  </div>
</template>

<script setup lang="ts">
import { PensionCategoriesEnum } from "#imports"
import { capitalize } from "lodash-es"

const props = defineProps<{
  policy: MyPensionPortfolioPolicy
  category: Nullable<PensionCategoriesEnum>
}>()

const currentProduct = useCurrentProductSettings(props)

const ScreenComponent = computed(() => {
  const category = capitalize(currentProduct.category.value || "")
  const productCategoryId = capitalize(currentProduct.productCategory.value || "")

  // If there is a subcategory, we need to load the component from the subcategory folder
  if (productCategoryId) {
    return lazy(() => import(`./OverviewTypes/${category}/${productCategoryId}.vue`))
  }

  return lazy(() => import(`./OverviewTypes/${category || productCategoryId}.vue`))
})
</script>
